export const domain = 'LinkPreviewModel'

export const onFetchLinkMetadata = `${domain}/onFetchLinkMetadata`
export const onFetchLinkMetadataSuccess = `${domain}/onFetchLinkMetadataSuccess`
